import localforage from 'localforage'

export default defineNuxtPlugin(() => {
    const localForage = localforage.createInstance({name: 'gpApp'})
    return {provide: {localForage}}
})
